
class PublicFAT {
    /**
     *  @class PublicFAT
     *  @alias module:src/server/com/silkplm/engine/files/PublicFAT.PublicFAT
     *
     * */
    constructor(){

            /** @type {string}  */
            this.downloadUrl = null;
            /** @type {number}  */
            this.firId = null;
            /** @type {string}  */
            this.mTm = null;
            /** @type {string}  */
            this.mime = null;
            /** @type {string}  */
            this.name = null;
            /** @type {number}  */
            this.size = null;
            /** @type {string}  */
            this.token = null;
            /** @type {string}  */
            this.uplBy = null;
            /** @type {string}  */
            this.url = null;
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/files/PublicFAT.PublicFAT}
     */
    withDownloadUrl(val){
            this.downloadUrl = val;
        return this;
    };
    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/engine/files/PublicFAT.PublicFAT}
     */
    withFirId(val){
            this.firId = val;
        return this;
    };
    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/files/PublicFAT.PublicFAT}
     */
    withMTm(val){
            this.mTm = val;
        return this;
    };
    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/files/PublicFAT.PublicFAT}
     */
    withMime(val){
            this.mime = val;
        return this;
    };
    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/files/PublicFAT.PublicFAT}
     */
    withName(val){
            this.name = val;
        return this;
    };
    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/engine/files/PublicFAT.PublicFAT}
     */
    withSize(val){
            this.size = val;
        return this;
    };
    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/files/PublicFAT.PublicFAT}
     */
    withToken(val){
            this.token = val;
        return this;
    };
    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/files/PublicFAT.PublicFAT}
     */
    withUplBy(val){
            this.uplBy = val;
        return this;
    };
    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/files/PublicFAT.PublicFAT}
     */
    withUrl(val){
            this.url = val;
        return this;
    };

}

let metadata = {};
metadata['downloadUrl'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['firId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['mTm'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['mime'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['name'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['size'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['token'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['uplBy'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['url'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
    metadata['data'] = {'remoteType' : 'java.util.Map', 'jsType' : 'Object', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.engine.files.PublicFAT';
metadata.__type_short__ = 'PublicFAT';

PublicFAT.prototype.__metadata__ = metadata;


/** @module src/server/com/silkplm/engine/files/PublicFAT */
export default PublicFAT

export { PublicFAT }
